/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_course_lecture_lecturepage_courseloading2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코스 정보를 불러오는 중...`)
};

const en_course_lecture_lecturepage_courseloading2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading course information...`)
};

const ja_course_lecture_lecturepage_courseloading2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コース情報を読み込み中...`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const course_lecture_lecturepage_courseloading2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.course_lecture_lecturepage_courseloading2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("course_lecture_lecturepage_courseloading2", locale)
	if (locale === "ko") return ko_course_lecture_lecturepage_courseloading2(inputs)
	if (locale === "en") return en_course_lecture_lecturepage_courseloading2(inputs)
	return ja_course_lecture_lecturepage_courseloading2(inputs)
};
export { course_lecture_lecturepage_courseloading2 as "course_lecture_lecturePage_courseLoading" }